const Footer = () => {
  return (
    <div className="relative">
      <div className="absolute left-[50%] top-0 bottom-0 bg-[#1A202C] w-[100vw] -z-10 -translate-x-2/4"></div>
      <div className="py-20 flex flex-col gap-2 items-center md:items-start">
        <h2 className="pb-8 flex-none font-quicksand text-4xl text-white">
          <span className="font-semibold">alston</span>
          <span className="font-extralight">applications</span>
        </h2>
        <a
          className="text-white font-poppins text-sm font-light"
          href="#services"
        >
          Our services
        </a>
        <a
          className="text-white font-poppins text-sm font-light"
          href="#testimonials"
        >
          Testimonials
        </a>
        <a
          className="text-white font-poppins text-sm font-light"
          href="/contact-us"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
};

export default Footer;
